var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteElementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52565 23.9167C7.94568 23.9167 7.4492 23.7102 7.0362 23.2971C6.62318 22.8841 6.41667 22.3876 6.41667 21.8077V7.00002H6.125C5.87708 7.00002 5.66927 6.91613 5.50156 6.74834C5.33385 6.58058 5.25 6.37268 5.25 6.12464C5.25 5.87663 5.33385 5.66887 5.50156 5.50135C5.66927 5.33382 5.87708 5.25005 6.125 5.25005H10.5C10.5 4.96437 10.6006 4.72095 10.8017 4.51978C11.0029 4.3186 11.2463 4.21802 11.532 4.21802H16.4679C16.7536 4.21802 16.997 4.3186 17.1982 4.51978C17.3994 4.72095 17.5 4.96437 17.5 5.25005H21.8749C22.1229 5.25005 22.3307 5.33394 22.4984 5.50173C22.6661 5.66952 22.7499 5.87742 22.7499 6.12543C22.7499 6.37346 22.6661 6.58124 22.4984 6.74875C22.3307 6.91627 22.1229 7.00002 21.8749 7.00002H21.5833V21.8077C21.5833 22.3876 21.3768 22.8841 20.9637 23.2971C20.5507 23.7102 20.0543 23.9167 19.4743 23.9167H8.52565ZM10.9712 19.8334H12.7211V9.33336H10.9712V19.8334ZM15.2788 19.8334H17.0288V9.33336H15.2788V19.8334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteElementIcon);
export default __webpack_public_path__ + "static/media/deleteElementIcon.80169e10.svg";
export { ForwardRef as ReactComponent };